// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv1S%-!!yVGpgFN9yRFSHai3_@b2i!b(Q!YVyQ[VQy@,Yt3SHae%oed>R!:pQaS9oe!pi!!(JRvIjXz7b!dIieZ9<yQ27--9baQ3YaJI<Vb(ee_S+ey:+R;6nSo9iVi7Q,a!Ne!:RV:pLyo,bSVe7+Z9Y!L2Y9[>7%@3pmd7<D1:itL>bRyS%Qmk%9;9Q4:I7@:9Q-!%e+FaKR<!jy)ajyQ6%d!!QtvIgR6>%X<2p@62%!F2bR@!K-$I<!FI_z<>K!vG<-@!jy$2iRQ6b-v!jyvIg!:ajzvaj@F2%d@I_y)IiR6I<4:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll';
